import consumer from "./consumer";

export const COMMENT_CABLE_EVENT = "comment_cable_event";

export function createCommentsSubscription(dispatch, { commentableType, commentableId }) {
  return consumer.subscriptions.create(
    {
      channel: "CommentsChannel",
      commentable_type: commentableType,
      commentable_id: commentableId,
    },
    {
      received(data) {
        if (!data?.comment || !dispatch) return;
        dispatch({
          type: COMMENT_CABLE_EVENT,
          payload: data,
        });
      },
    }
  );
}
